import { render, staticRenderFns } from "./ScopeOfWorks.vue?vue&type=template&id=7c8b3274&"
import script from "./ScopeOfWorks.vue?vue&type=script&lang=js&"
export * from "./ScopeOfWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports